import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import { addSectionHeading } from '~/api';
import UndoButton from '~/components/common/undo-button';
import ExpandCollapseAll from '~/components/common/expand-collapse-all';

/**
 * Header section for our course and quiz builders.
 * Shows the number of lessons/questions in a builder, the undo button and the Expand/Collapse All toggle.
 *
 * @callback onUndo
 * @param {Object} props
 * @param {number} props.totalEntities
 * @param {string} props.type
 * @param {string} props.singular
 * @param {string} props.plural
 * @param {boolean} props.showUndo
 * @param {onUndo} props.onUndo
 * @param {Object|Array} props.workspace
 */
const EntityBuilderHeader = ( {
	totalEntities,
	type,
	singular,
	plural,
	showUndo,
	onUndo,
	workspace,
} ) => (
	<header className="ld-entity-builder-header">
		<div>
			<h2>
				{ totalEntities } { 1 === totalEntities ? singular : plural }{ ' ' }
				{ `${ LearnDashData.i18n.in_this } ${ type }` }
			</h2>
		</div>

		{ showUndo && (
			<UndoButton
				undoActionHandler={ ( e ) => {
					e.preventDefault();
					onUndo();

					// If undoing affects section headings, update post meta
					if (
						'sfwd-quiz' !==
							LearnDashData.post_data.builder_post_type &&
						0 <
							workspace.past[ workspace.past.length - 1 ].sections
								.length
					) {
						if (
							workspace.past[ workspace.past.length - 1 ]
								.sections !== workspace.present.sections
						) {
							addSectionHeading(
								LearnDashData.post_data.builder_post_id,
								workspace.past[ workspace.past.length - 1 ]
									.sections
							);
						}
					}
				} }
			/>
		) }

		{ 0 !== totalEntities && <ExpandCollapseAll /> }
	</header>
);

/**
 * Valid props
 */
EntityBuilderHeader.propTypes = {
	workspace: PropTypes.shape( {
		present: PropTypes.object,
		past: PropTypes.array,
	} ),
	totalEntities: PropTypes.number,
	type: PropTypes.string,
	singular: PropTypes.string,
	plural: PropTypes.string,
	onUndo: PropTypes.func,
	showUndo: PropTypes.bool,
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => {
	return {
		workspace: state.workspace,
	};
};

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = ( dispatch ) => ( {
	onUndo: () => dispatch( UndoActionCreators.undo() ),
} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( EntityBuilderHeader );
